module.exports = __webpack_public_path__ + "img/loggigwi1.0e0a36db.png";